<template>
  <div class="notice">
    <ul>
      <li v-for="(item, index) in columnList" :key="index" class="flex">
        <span class="flex-box" @click="navHandle(item.strId)">{{ item.strName }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "News",
  data() {
    return {};
  },
  props: {
    columnList: {
      type: Array,
      default: () => []
    }
  },
  created() {},
  methods: {
    // 更多菜单跳转
    navHandle(strId) {
      this.$router.push({
        path: "/list",
        query: { strId: strId, strWebSiteId: this.$route.query.strWebSiteId }
      });
    }
  }
};
</script>

<style scoped lang="less">
.notice {
  width: 225px;
  min-height: 500px;
  // }
  ul {
    box-sizing: border-box;
    padding: 10px 10px 5px;
    margin: 0;
    li {
      box-sizing: border-box;
      margin-top: 10px;
      font-size: 14px;
      color: #fff;
      width: 160px;
      height: 40px;
      line-height: 40px;
      background: url("../../assets/images/nav-bg.png") no-repeat center center;
      background-size: 100% 100%;
      text-align: center;
      cursor: pointer;
      span {
        display: block;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 18px;
      }
      i {
        font-style: normal;
        color: #999;
        font-family: "SimSun";
      }
    }
  }
}
</style>